import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import { detectPlatform } from "../utilities/deviceDetection";

/**
 * Builds the desktop app download URL with proper locale and tracking
 */
const buildDesktopAppUrl = (defaultStoreUrl, ctaRef) => {
  // Ensure defaultStoreUrl has a trailing slash so URL constructor treats path as a directory
  const baseUrl = defaultStoreUrl.endsWith("/")
    ? defaultStoreUrl
    : `${defaultStoreUrl}/`;

  const url = new URL("discover/our-apps", baseUrl);
  if (ctaRef) {
    url.searchParams.set("ctaRef", ctaRef);
  }
  return url.toString();
};

const buildMobileAppUrl = (ctaRef) => {
  const appUrl = "https://asos-medialabs.onelink.me/PXyX";
  const url = new URL(appUrl);
  if (ctaRef) {
    url.searchParams.set("ctaRef", ctaRef);
  }
  return url.toString();
};

export const useGetAppDownloadUrl = ({ ctaRef, defaultStoreUrl }) => {
  const [appDownloadUrl, setAppDownloadUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [osPlatform, setOsPlatform] = useState(null);

  useEffect(() => {
    const platform = detectPlatform();
    setOsPlatform(platform);

    // For mobile devices, get the app store URL
    if (platform === "ios" || platform === "android") {
      const appStoreUrl = buildMobileAppUrl(ctaRef);
      setAppDownloadUrl(appStoreUrl);
    } else {
      // For desktop, use the discover/our-apps page with locale
      const desktopUrl = buildDesktopAppUrl(defaultStoreUrl, ctaRef);
      setAppDownloadUrl(desktopUrl);
    }

    setIsLoading(false);
  }, [ctaRef, defaultStoreUrl]);

  return { appDownloadUrl, osPlatform, isLoading };
};

useGetAppDownloadUrl.propTypes = {
  ctaRef: PropTypes.string,
  defaultStoreUrl: PropTypes.string.isRequired,
};
